var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCreditCards = function SvgCreditCards(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 22,
    viewBox: "0 0 31 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.192 13.936a2 2 0 0 1-.464.704 2.56 2.56 0 0 1-.704.464l-2.832 1.168V8.416a3.616 3.616 0 0 0-1.072-2.56A3.696 3.696 0 0 0 22.544 4.8h-9.728L22.896.624a2.56 2.56 0 0 1 .848-.144c.284 0 .565.048.832.144.262.109.5.266.704.464.206.2.37.44.48.704l4.416 10.496c.221.526.227 1.118.016 1.648z",
    fill: "#164076",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#164076",
    y: 6,
    width: 25,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F67347",
    d: "M0 10h25v3H0z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCreditCards, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/credit-cards.9bfd1416.svg";
export { ForwardRef as ReactComponent };